import { useState } from 'react'
import DatePicker from 'react-datepicker'
import Alert from "react-bootstrap/Alert"
import SearchButton from "./../Components/SearchButton"
import moment from 'moment'

function Home() {
  const [controlNum, setControlNum] = useState('')
  const [deliveryZip, setDeliveryZip] = useState('')
  const [approxDate, setApproxDate] = useState('')

  const [show, setShow] = useState('none')
  const [showSearchForm, setShowSearchForm] = useState(true)
  const [searchStatus, setSearchStatus] = useState('start')
  const [searchButtonDisabled, setSearchButtonDisabled] = useState(false)
  const [errorMsg, setErrorMsg] = useState(null)

  // Accepts letters, numbers and dashes. Accepts 1-20 characters.
  // TODO: Review and adjust criteria.
  const reControlNum = /^[a-z0-9-]{1,20}$/i
  
  // Accepts US ZIP and ZIP+4 codes, Canada postal codes.
  const rePostalCode = /(^[0-9]{5,5}(-[0-9]{4,4})?$)|(^[a-z][0-9][a-z][ -]?[0-9][a-z][0-9]$)/i
  
  // Accepts format MM/DD/YYYY. (No further validation.)
  const reDate = /^[0-9]{2,2}\/[0-9]{2,2}\/[0-9]{4,4}$/

  // Unused callback from datepicker.
  const selectedDate = (date) => {}

  const handleChangeControlNumber = (event) => {
    if (show === "block") setShow("none")
    clearError()
    setControlNum(event.target.value)
  }

  const handleChangeDeliveryZip = (event) => {
    if (show === "block") setShow("none")
    clearError()
    setDeliveryZip(event.target.value)
  }

  const handleChangeApproxDate = (date) => {
    let str = moment.utc(date).local().format('MM/DD/yyyy')
    if (show === "block") setShow("none")
    clearError()
    setApproxDate(str)
  }

  const showError = (errors) => {
    var msg = ''
    errors.map(e => { msg = msg ? `${msg} ${e}` : e })
    setErrorMsg(msg)
    setShow("block")
  }

  const clearError = () => {
    setErrorMsg(null)
    setShow("none")
  }

  const handleSearch = () => {
    let errors = []
    clearError()

    if (!isValidControlNumber(controlNum)) {
      errors.push(`Please enter a valid control number or PRO number.`)
    }

    if (!isValidDeliveryZip(deliveryZip)) {
      errors.push(`Please enter a valid ZIP or postal code for the delivery location.`)
    }

    if (!isValidApproxDate(approxDate)) {
      errors.push(`Please enter a valid date for the shipment (pickup or delivery).`)
    }

    if (errors.length) {
      showError(errors)
      return
    }

    let dateStr = moment(approxDate).format('yyyy-MM-DD')

    setShow("none")
    setSearchStatus('searching')
    setSearchButtonDisabled(true)
    search(controlNum, deliveryZip, dateStr)
  }

  const isValidControlNumber = (val) => {
    return (!!val && reControlNum.test(val))
  }

  const isValidDeliveryZip = (val) => {
    return (!!val && rePostalCode.test(val))
  }

  const isValidApproxDate = (val) => {
    console.log(val)
    return (!!val && reDate.test(val))
  }

  const search = (controlNum, deliveryZip, approxDate) => {
    document.location = `/Detail/${controlNum}?zip=${deliveryZip}&dt=${approxDate}`
  }

  const style = { display: show }

  return (
    <div>
      <div><h1>Where&rsquo;s My Shipment?</h1></div>
      <div className="input-row">
        <input
          type="text"
          className="form-control search-text"
          id="controlNum"
          aria-describedby="controlNumberHelp"
          placeholder="Tracking Number"
          value={controlNum}
          onChange={handleChangeControlNumber}
        />
      </div>
      <div className="input-row">
        <input
          type="text"
          className="form-control delivery-zip"
          id="deliveryZip"
          aria-describedby="deliveryZipHelp"
          placeholder="Delivery ZIP or Postal Code"
          value={deliveryZip}
          onChange={handleChangeDeliveryZip}
        />
      </div>
      <div className="input-row">
      <DatePicker
        className="form-control approx-date"
        selected={approxDate}
        onChange={handleChangeApproxDate}
        placeholderText="Approximate Date"
        dateFormat="MM/dd/yyyy"
      />
      </div>
      <div className="text-center">
        <SearchButton action={handleSearch} />
      </div>
      <div>
        <div className="searchAlertDiv">
          <Alert variant="danger" style={style}>
            <div id="errorMsg">{errorMsg}</div>
          </Alert>
        </div>
      </div>
    </div>
  )
}

export default Home
